const es = {
  seo: {
    home: {
      title: "Wild Spoon — Chef privado en Granada | Cenas privadas en el Albaicín",
      description: "Wild Spoon, experiencias gastronómicas privadas de Edu Vincent, cocinero autodidacta franco-catalán en el Albaicín de Granada: cenas privadas en el Albaicín de Granada o chef a domicilio en tu alojamiento. Grupos a partir de 4 personas.",
    },
    reservas: {
      title: "Reserva tu experiencia — Wild Spoon | Chef privado Granada",
      description: "Solicita tu cena privada con Wild Spoon: en casa de Edu, en el Albaicín de Granada, o con chef privado a domicilio. Edu confirma personalmente la disponibilidad.",
    },
    legal: {
      title: "Información legal — Wild Spoon",
      description: "Información legal, privacidad y cookies de Wild Spoon, experiencias gastronómicas privadas de Edu Vincent en Granada.",
    },
    notFound: {
      title: "Página no encontrada — Wild Spoon",
      description: "La página que buscas no existe o ha cambiado de dirección.",
    },
  },
  nav: {
    experiencias: "Experiencias",
    cocina: "La cocina",
    edouard: "Edu",
    galeria: "Galería",
    opiniones: "Opiniones",
    contacto: "Contacto",
    reservar: "Reservar",
  },
  hero: {
    overline: "Wild Spoon",
    titleA: "Cocina con carácter.",
    titleB: "Una mesa en el Albaicín.",
    subtitle: "Experiencias gastronómicas privadas creadas por Edu Vincent en el corazón del Albaicín, o directamente en tu casa.",
    ctaPrimary: "Reservar una experiencia",
    ctaSecondary: "Descubrir Wild Spoon",
    note: "A partir de 4 personas · Granada",
    scroll: "Desliza",
    imageAlt: "Edu Vincent en su casa del Albaicín (fotografía real)",
  },
  marquee: {
    words: ["fuego", "instinto", "generosidad", "creatividad", "compartir"],
  },
  intro: {
    overline: "El concepto",
    title: "Comer bien, abrir una botella y sentarse a la mesa sin prisas.",
    p1: "Wild Spoon nace alrededor de una idea sencilla: comer bien, abrir una botella y sentarse alrededor de una mesa sin prisas.",
    p2: "Edu Vincent crea experiencias gastronómicas privadas en Granada para pequeños grupos, tanto en su propia casa como desplazándose hasta la tuya.",
    meta: "Cocina privada · Albaicín, Granada · Grupos desde 4 personas",
  },
  menus: {
    overline: "Menús",
    title: "Tres maneras de sentarse a la mesa.",
    perPerson: "por persona",
    note: "Un menú pensado para cada mesa y cada ocasión. El mínimo para reservar son 4 personas.",
    rows: [
      { n: "5", label: "tiempos", price: "75" },
      { n: "6", label: "tiempos", price: "90" },
      { n: "7", label: "tiempos", price: "100" },
    ],
  },
  twoWays: {
    overline: "Dos formas de vivir Wild Spoon",
    title: "Una misma mesa, dos escenarios.",
    block1: {
      tag: "En casa de Edu",
      title: "Una mesa en el Albaicín",
      text: "En el corazón de Granada, Edu abre las puertas de su casa para recibir a pequeños grupos alrededor de su mesa. Cocina, conversación y sobremesa en una casa con todo el carácter del Albaicín.",
      location: "Albaicín · Granada",
      note: "La dirección exacta se facilita cuando la reserva está confirmada.",
      cta: "Reservar una experiencia",
      imageAlt: "Pastilla de cordero con batata de Wild Spoon, servida en casa de Edu (fotografía real)",
    },
    block2: {
      tag: "Wild Spoon en tu casa",
      title: "Edu cocina. Tú disfrutas.",
      text: "Wild Spoon también puede desplazarse hasta tu casa, villa, apartamento o alojamiento en Granada y alrededores. Edu se ocupa de la cocina para que vosotros simplemente os ocupéis de disfrutar de la mesa.",
      forWhom: "Ideal para:",
      list: ["Vacaciones en Granada", "Reuniones de amigos", "Celebraciones familiares", "Villas y casas rurales", "Ocasiones especiales", "Pequeños grupos privados"],
      cta: "Consultar disponibilidad",
      imageAlt: "Cocina con carácter: emplatado de Wild Spoon (fotografía real)",
    },
  },
  cocina: {
    overline: "La cocina",
    title: "Sin fronteras. Sin reglas innecesarias.",
    lead: "Una cocina libre, personal y sin fronteras: entre Francia y España, con la memoria de la cocina de una abuela gallega y la mirada puesta en cada mesa.",
    chapters: [
      { n: "01", t: "Fuego", d: "Brasas, cocciones lentas y sabores intensos." },
      { n: "02", t: "Instinto", d: "La receta es un punto de partida, no una limitación." },
      { n: "03", t: "Producto", d: "Cada ingrediente tiene algo que decir." },
      { n: "04", t: "Generosidad", d: "Platos cuidados, pero nunca tímidos." },
      { n: "05", t: "Memoria", d: "Francia, España, Galicia, viajes, recetas familiares." },
      { n: "06", t: "Curiosidad", d: "Tomar algo conocido y llevarlo a otro lugar." },
    ],
    mainImageAlt: "Cocción lenta al fuego en la cocina de Edu (fotografía real)",
    wideImageAlt: "El arroz de ternera en la paella, para el centro de la mesa (fotografía real)",
    sign: "Wild Spoon — Fuego. Carácter. Generosidad.",
  },
  edouard: {
    overline: "Edu",
    name: "Edu Vincent",
    subtitle: "Cocinero autodidacta. Franco-catalán. Salvaje por naturaleza.",
    bio: [
      "Franco-catalán y cocinero autodidacta, he construido mi cocina entre dos culturas, alimentada por las tradiciones francesas y españolas y por los recuerdos de la cocina de mi abuela gallega.",
      "Mi cocina es instintiva, generosa y decididamente salvaje.",
      "Me gustan el fuego, las brasas, las cocciones lentas, las salsas profundas, la acidez, el crujiente y los sabores francos. Busco platos bonitos y cuidados, pero nunca tímidos: para mí, la generosidad también forma parte de la elegancia.",
      "Sobre todo, me gusta partir de una receta que creemos conocer, respetar su esencia y llevarla un poco más lejos. Trabajar las texturas, intensificar los sabores, introducir un detalle inesperado… hasta convertir algo familiar en una experiencia diferente.",
      "Cocino sin fronteras y sin reglas innecesarias. Con instinto, fuego, creatividad y una obsesión: que cada bocado tenga algo que contar.",
      "Porque para mí la cocina sigue siendo, ante todo, un momento para compartir, disfrutar y sentarse juntos alrededor de una mesa.",
    ],
    sign: "Wild Spoon — fuego, carácter y generosidad.",
    photoCaption: "Edu Vincent en la terraza de su casa del Albaicín — fotografía real",
    imageAlt: "Edu Vincent en la terraza de su casa, con chaqueta negra (fotografía real)",
  },
  testimonios: {
    overline: "Opiniones",
    title: "Lo cuentan quienes se han sentado a la mesa.",
    lead: "Valoraciones reales de viajeros que han vivido la experiencia con Edu y las han dejado escritas en Sazón The Folk Cook, la plataforma donde también ofrece sus experiencias.",
    emptyTitle: "Las reseñas llegarán muy pronto a este espacio.",
    emptyText: "Estamos preparando una selección de las valoraciones reales de quienes ya han vivido la experiencia.",
  },
  granada: {
    overline: "Granada",
    title: "Granada también se sienta a la mesa.",
    text: "Wild Spoon nació en el Albaicín, en el corazón de Granada. Una ciudad de culturas mezcladas, sobremesas largas y sabores que llevan siglos viajando de un lado a otro.",
    meta: "Albaicín · Granada · España",
  },
  sazon: {
    overline: "Reputación",
    title: "Años cocinando para viajeros de todo el mundo.",
    text: "Edu también ofrece experiencias gastronómicas a través de Sazón The Folk Cook.",
    cta: "Ver perfil en Sazón",
  },
  galeria: {
    overline: "Galería",
    title: "Instantáneas de Wild Spoon.",
    filters: { todas: "Todo", platos: "Platos", postres: "Postres", cocina: "La cocina", edouard: "Edu" },
  },
  ctaBand: {
    title: "¿Preparados para sentarse a la mesa?",
    text: "Cuéntanos la fecha y cuántos sois. Edu comprobará personalmente la disponibilidad y te confirmará.",
    cta: "Reservar tu experiencia",
  },
  reservas: {
    overline: "Reservas",
    title: "Reserva tu experiencia",
    lead: "Cuéntanos qué fecha, cuántos sois y qué experiencia prefieres. Edu comprobará personalmente la disponibilidad. Menús de 5, 6 o 7 tiempos, desde 75€ por persona.",
    notice: "Tu solicitud no estará confirmada hasta recibir la confirmación personal de Edu.",
    stepsTitle: "Cómo funciona",
    steps: [
      { t: "Envías la solicitud", d: "Nos cuentas la fecha, el número de personas y el tipo de experiencia." },
      { t: "Edu la revisa", d: "Comprueba personalmente la disponibilidad y se pone en contacto contigo." },
      { t: "Confirmas tu mesa", d: "Solo cuando Edu confirma, tu reserva queda hecha." },
    ],
    form: {
      nombre: "Nombre",
      nombrePh: "Tu nombre",
      apellidos: "Apellidos",
      apellidosPh: "Tus apellidos",
      email: "Email",
      emailPh: "tu@email.com",
      telefono: "Teléfono / WhatsApp",
      telefonoPh: "+34 600 000 000",
      fecha: "Fecha deseada",
      personas: "Número de personas",
      personasMin: "Wild Spoon está disponible para grupos a partir de 4 personas.",
      tipo: "Tipo de experiencia",
      tipoEdouard: "En casa de Edu — Albaicín",
      tipoEdouardHint: "Cena privada en su mesa, en el Albaicín",
      tipoDomicilio: "Chef privado a domicilio",
      tipoDomicilioHint: "Edu cocina donde te alojas",
      direccion: "Dirección o zona donde se realizará la experiencia",
      direccionPh: "Nombre del alojamiento, calle, zona…",
      idioma: "Idioma preferido",
      idiomas: ["Español", "English", "Français", "Otro"],
      alergias: "Alergias, intolerancias o necesidades alimentarias",
      alergiasPh: "Cuéntanos cualquier necesidad alimentaria del grupo",
      mensaje: "Mensaje / ocasión especial",
      mensajePh: "Celebración, aniversario, simplemente una buena cena…",
      acepto: "He leído y entiendo que esta solicitud está sujeta a disponibilidad y que la reserva solo quedará confirmada cuando reciba la confirmación de Wild Spoon.",
      submit: "Solicitar disponibilidad",
      required: "Campo obligatorio",
      invalidEmail: "Introduce un email válido",
      aceptoRequired: "Debes aceptar la condición de confirmación para enviar la solicitud.",
      direccionRequired: "Indica la dirección o zona donde se realizará la experiencia.",
      fechaRequired: "Selecciona una fecha futura.",
      submitting: "Enviando…",
      error: "No se pudo enviar la solicitud. Inténtalo de nuevo o escríbenos por contacto.",
    },
    success: {
      title: "Solicitud recibida",
      p1: "Gracias por contactar con Wild Spoon.",
      p2: "Edu revisará personalmente la disponibilidad para la fecha solicitada y se pondrá en contacto contigo.",
      p3: "Recuerda que la reserva todavía no está confirmada.",
      cta: "Volver al inicio",
    },
  },
  contacto: {
    overline: "Contacto",
    title: "Hablemos de tu mesa.",
    lead: "Para cualquier duda sobre las experiencias, escríbenos y te responderemos personalmente.",
    location: "Granada y alrededores",
    form: {
      nombre: "Nombre",
      email: "Email",
      telefono: "Teléfono",
      mensaje: "Mensaje",
      submit: "Enviar mensaje",
      submitting: "Enviando…",
      success: "Mensaje enviado. Gracias por escribir, te responderemos personalmente.",
      error: "No se pudo enviar el mensaje. Inténtalo de nuevo.",
      required: "Campo obligatorio",
    },
    whatsapp: "Escríbenos por WhatsApp",
  },
  footer: {
    brandPhrase: "Fuego. Carácter. Generosidad.",
    tagline: "Cocina privada en Granada. Experiencias gastronómicas alrededor de una mesa.",
    navTitle: "Descubre",
    nav: { experiencias: "Experiencias", reservas: "Reservas", contacto: "Contacto" },
    legalTitle: "Legal",
    legal: { aviso: "Aviso legal", privacidad: "Privacidad", cookies: "Cookies" },
    lang: "Idioma",
    rights: "Todos los derechos reservados.",
  },
  legal: {
    aviso: {
      title: "Aviso legal",
      blocks: [
        { h: "Titular del sitio web", p: [
          "Titular / Responsable: Edouard Vincent.",
          "Nombre comercial: Wild Spoon.",
          "NIE: Y4953298D.",
          "Domicilio: Calle Carnero 4, 2B, 18010 Granada, España.",
          "E-mail de contacto y reservas: evincent.molas@gmail.com.",
          "Sitio web: https://wild-spoon.com",
        ] },
        { h: "Objeto", p: [
          "Edouard Vincent explota el sitio web https://wild-spoon.com bajo el nombre comercial Wild Spoon para ofrecer experiencias gastronómicas privadas en Granada y alrededores, tanto en su propio domicilio como a domicilio del cliente, así como servicios de cocinero privado para grupos desde 4 personas.",
        ] },
        { h: "Condiciones de uso", p: [
          "El acceso y la navegación por el sitio web implican la aceptación de las presentes condiciones. El usuario se compromete a hacer un uso adecuado de los contenidos y a no emplearlos para actividades ilícitas.",
          "Las solicitudes de reserva enviadas a través del formulario no constituyen una reserva confirmada: quedan sujetas a disponibilidad y solo quedan confirmadas cuando Edu comunica personalmente su confirmación al cliente.",
        ] },
        { h: "Propiedad intelectual e industrial", p: [
          "Todos los contenidos del sitio (textos, fotografías, vídeos, logotipos y diseño) son titularidad de Edouard Vincent o de terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin autorización.",
        ] },
        { h: "Responsabilidad", p: [
          "El titular no se responsabiliza de las decisiones tomadas a partir de los contenidos publicados en el sitio, ni de los daños que pudieran derivarse de interferencias, omisiones o interrupciones ajenas a su control.",
          "Este sitio puede contener enlaces a sitios web de terceros (por ejemplo, plataformas donde también se ofrecen las experiencias) sobre cuyos contenidos no se ejerce control alguno.",
        ] },
        { h: "Legislación aplicable y jurisdicción", p: [
          "La relación entre el titular y el usuario se regirá por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales del domicilio del consumidor, de conformidad con la normativa aplicable.",
        ] },
      ],
    },
    privacidad: {
      title: "Política de privacidad",
      blocks: [
        { h: "Responsable del tratamiento", p: [
          "Responsable: Edouard Vincent (nombre comercial: Wild Spoon).",
          "NIE: Y4953298D.",
          "Dirección: Calle Carnero 4, 2B, 18010 Granada, España.",
          "E-mail: evincent.molas@gmail.com.",
        ] },
        { h: "Datos que tratamos", p: [
          "A través del formulario de reserva: nombre y apellidos, e-mail, teléfono / WhatsApp, fecha deseada, número de personas, tipo de experiencia, dirección o zona (si la prestación es a domicilio), idioma preferido, alergias, intolerancias o necesidades alimentarias y, en su caso, el mensaje u ocasión especial.",
          "A través del formulario de contacto: nombre, e-mail, teléfono (opcional) y mensaje.",
        ] },
        { h: "Finalidades del tratamiento", p: [
          "Gestionar las solicitudes de reserva.",
          "Contactar al cliente.",
          "Organizar la prestación del servicio.",
          "Responder a las demandas enviadas a través del formulario de contacto.",
          "Cumplir con las obligaciones legales aplicables.",
        ] },
        { h: "Base jurídica", p: [
          "La ejecución de un contrato o la aplicación de medidas precontractuales (art. 6.1.b del RGPD) para la gestión de solicitudes de reserva y consultas.",
          "El consentimiento (art. 6.1.a del RGPD) para el tratamiento de alergias, intolerancias o necesidades alimentarias, por tratarse de datos relacionados con la salud, y para el uso de cookies no estrictamente necesarias.",
        ] },
        { h: "Comunicaciones internas y encargados del tratamiento", p: [
          "Cada solicitud o mensaje recibido puede generar una notificación interna enviada a evincent.molas@gmail.com.",
          "El envío de e-mails se realiza a través de Resend, prestador técnico de servicios de envío de correo electrónico que actúa como encargado del tratamiento. La utilización de este prestador puede implicar transferencias internacionales de datos, amparadas en las garantías previstas por el RGPD (cláusulas contractuales tipo u otras garantías adecuadas).",
          "No se ceden datos a terceros con fines de marketing. No se envían comunicaciones comerciales sin un consentimiento expreso y diferenciado.",
        ] },
        { h: "Conservación de los datos", p: [
          "Los datos se conservarán durante el tiempo necesario para gestionar la solicitud o consulta y, en su caso, la prestación del servicio, así como durante los plazos exigidos por la legislación aplicable.",
        ] },
        { h: "Derechos", p: [
          "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad dirigiéndote por e-mail a evincent.molas@gmail.com.",
          "Asimismo, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que no se ha atendido correctamente el ejercicio de tus derechos.",
        ] },
        { h: "Seguridad y actualización de la política", p: [
          "Se aplican medidas técnicas y organizativas apropiadas para proteger los datos personales. Esta política puede actualizarse; en esta página se publica siempre la versión vigente.",
        ] },
      ],
    },
    cookies: {
      title: "Política de cookies",
      blocks: [
        { h: "Qué son las cookies", p: [
          "Las cookies y tecnologías similares (como el almacenamiento local) son pequeños archivos que se guardan en tu dispositivo y que permiten almacenar y recuperar información sobre tu navegación.",
        ] },
        { h: "Cookies estrictamente necesarias", p: [
          "Este sitio utiliza únicamente almacenamiento estrictamente necesario para su funcionamiento: la preferencia de idioma seleccionada y el estado de tu consentimiento de cookies. Estos elementos no requieren consentimiento.",
        ] },
        { h: "Cookies analíticas", p: [
          "Si otorgas tu consentimiento, el sitio carga una herramienta de estadísticas de terceros (PostHog) que registra de forma anónima la interacción con las páginas con el fin de mejorar la experiencia. Esta carga solo se produce después de aceptar y puede retirarse en cualquier momento.",
        ] },
        { h: "Cómo gestionar o retirar el consentimiento", p: [
          "Puedes aceptar, rechazar o configurar las cookies desde el aviso de consentimiento y, en cualquier momento, desde el enlace «Configurar las cookies» disponible en el pie de página. La retirada del consentimiento es tan sencilla como su otorgamiento.",
        ] },
      ],
    },
  },
  cookiesUI: {
    title: "Tu privacidad",
    text: "Este sitio utiliza cookies estrictamente necesarias para funcionar (idioma y esta preferencia) y, solo con tu consentimiento, una herramienta de analítica anónima para mejorarlo.",
    accept: "Aceptar",
    reject: "Rechazar",
    config: "Configurar",
    save: "Guardar preferencias",
    necessary: "Estrictamente necesarias",
    necessaryDesc: "Idioma seleccionado y tu consentimiento. Siempre activas.",
    analytics: "Analítica anónima",
    analyticsDesc: "Estadísticas de uso anónimas (PostHog) para mejorar el sitio. Solo se cargan si las aceptas.",
    footerLink: "Configurar las cookies",
  },
  common: {
    notFoundTitle: "Página no encontrada",
    notFoundText: "La página que buscas no existe o ha cambiado de dirección.",
    backHome: "Volver al inicio",
  },
};

export default es;
